import { render } from "./AppTitle.vue?vue&type=template&id=6c7b8032&scoped=true"
import script from "./AppTitle.vue?vue&type=script&lang=js"
export * from "./AppTitle.vue?vue&type=script&lang=js"

import "./AppTitle.vue?vue&type=style&index=0&id=6c7b8032&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\astac\\OneDrive\\Рабочий стол\\twodolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7b8032"]])

export default __exports__